import { useContext } from 'react';
import { formErrorContext } from '../../context';
export var useCreditCardFailure = function useCreditCardFailure() {
  return useContext(formErrorContext)[0];
};
export var useSetCreditCardFailure = function useSetCreditCardFailure() {
  return useContext(formErrorContext)[1];
};